import type { ChangeEvent, InputHTMLAttributes } from "react";
import styles from "./TextInput.module.css";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
	value: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	variant?: "default" | "onboarding";
	error?: boolean;
}

export function TextInput({
	value,
	onChange,
	variant = "default",
	error = false,
	className = "",
	...props
}: TextInputProps) {
	return (
		<input
			{...props}
			type="text"
			value={value}
			onChange={onChange}
			className={`${styles.input} ${styles[variant]} ${error ? styles.error : ""} ${className}`}
		/>
	);
}
